import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Src1 from '../../../assets/images/s2_4_img1.png';
import Src2 from '../../../assets/images/s2_4_img2.png';
import Src3 from '../../../assets/images/s2_4_img3.png';
import Src4 from '../../../assets/images/s2_4_img4.png';
import Src5 from '../../../assets/images/s2_4_img5.png';

import Src6 from '../../../assets/images/s2_4_img6.png';
import Src7 from '../../../assets/images/s2_4_img7.png';
import Src8 from '../../../assets/images/s2_4_img8.png';
import Src9 from '../../../assets/images/s2_4_img9.png';
import Src10 from '../../../assets/images/s2_4_img10.png';

import Src11 from '../../../assets/images/s2_4_img11.png';
import Src12 from '../../../assets/images/s2_4_img12.png';
import Src13 from '../../../assets/images/s2_4_img13.png';

export default function Content() {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false, 
    customPaging: function(i) {
      return (
        <div className="custom-dot"></div>
      );
    },
    dotsClass: "slick-dots custom-dots"
  };

  const sliderImages = [Src11, Src12, Src13];

  return (
    <>
      <div className="s2_4_content">
        <div className="col-flex flex-center ">
          <img src={Src1} alt="" />
          <img src={Src2} alt="" />
          <img src={Src3} alt="" />
          <img src={Src4} alt="" />
          <img src={Src5} alt="" />
          <img src={Src6} alt="" />
          <img src={Src7} alt="" />
          <img src={Src8} alt="" />
          <img src={Src9} alt="" />
          <img src={Src10} alt="" />
        </div>

        <div className="txt-center mt-10 mb-3 ">
          <p className="prt-medium fs-20 fc-005eed mb-1">마케팅 사례</p>
          <p className="prt-bold fs-50 fc-black1 lh-13">
            다양한 고객 사례를 만나보세요
          </p>
        </div>
      </div>

      <div className="center  pb-10">
        <div className="marketing_slider ">
          <Slider {...settings}>
            {sliderImages.map((src, index) => (
              <div key={index} className="slider-item">
                <img src={src} alt={`마케팅 ${index + 1}`} 
                className="slider-image" />
              </div>
            ))}
          </Slider>
        </div>
      </div>

     
    </>
  );
}